export const isCurrentRoute = (currentRoute : string, validRoutes:string[]) => {
    return validRoutes.includes(currentRoute);
};